import dayjs from "dayjs";
import $thousandMask from "@/mixins/thousandMask";
export default {
  name: "deposit-crypto-detail",
  components: {},
  props: ["data"],
  mixins: [$thousandMask],
  data() {
    return {};
  },
  filters: {
    formatDate(date) {
      let format =
        localStorage.getItem("lang") === "fa"
          ? "YYYY/MM/DD - HH:mm"
          : "YYYY/DD/MM - HH:mm";
      return dayjs(date).format(format);
    }
  },
  computed: {},
  mounted() {},
  methods: {}
};
